export class ConfigsChatbot {

    constructor(
        public chatbotExpiration?: string,
		public chatbotUrlWsdl?: string,
		public chatbotUrlCertsys?: string
    ){}
}


// WEBPACK FOOTER //
// ./src/app/components/base/vo/configs-chatbot.ts